import unixTimeConverter from './unixTimeConverter';

const normalizeVisualCrossing = (data) => {
    var date = new Date();
    var currentHour = date.getHours();

    const newObject = {};

    newObject.current = {};
    newObject.current.temp = Math.trunc(data.currentConditions.temp);

    newObject.daily = [];
    data.days.map((day) => 
        newObject.daily.push(
            {date: unixTimeConverter(day.datetimeEpoch, 'day'),
             date_unix: day.datetimeEpoch,
             tempMin: Math.trunc(day.tempmin),
             tempMax: Math.trunc(day.tempmax),
             iconSrc: `/icons/${day.icon}.png`,
             wind: Math.trunc(day.windspeed),
             rainProb: Math.trunc(day.precipprob),
             rain: Math.round(day.precip * 10) / 10
            }
        )
    )

    newObject.hourly = [];
    data.days.map((day, dayIndex) => 
        day.hours.map((hour, hourIndex) =>
            // Esta api envía las horas desde las 00:00, no desde la hora actual, 
            // así que calculo primero la hora actual para que mapee el array a   
            // partir del index que coincida con la hora actual.
            // También ofrece el tiempo hora a hora para los próximos 14 días,
            // para que no cargue tantas horas lo limito a 4 días.
            ((dayIndex === 0 && hourIndex < currentHour) || dayIndex >= 3) 
            ? null
            : newObject.hourly.push(
                {hour: unixTimeConverter(hour.datetimeEpoch, 'hour'),
                hour_unix: hour.datetimeEpoch,
                temp: Math.trunc(hour.temp),
                iconSrc: `/icons/${hour.icon}.png`,
                wind: Math.trunc(hour.windspeed),
                rainProb: Math.trunc(hour.precipprob),
                rain: Math.round(hour.precip * 10) / 10
                }
            )
        )
    )

    return newObject;
}

export default normalizeVisualCrossing;
